import { Fragment, useState, useEffect, useMemo } from "react";
import React from "react";
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { withRouter } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import esLocale from "date-fns/locale/es";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { obtenerGuiaByIdentificador, setInitialData, obtenerGuiaMagueyConsultaGuia } from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";
import { getBottomNavigationActionUtilityClass } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { obtenerClientesDetalleLike, obtenerTodosLosClientesConDetalle, obtenerTodosLosClientesConsulta } from "../../../redux/InformacionValidaDucks";
import { agregarNuevaListaGuia, agregarGuia } from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import { useStateIfMounted } from "use-state-if-mounted";
import { obtenerDatosPredioByIdCliente } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { v4 as uuidv4 } from "uuid";
import Tooltip from '@mui/material/Tooltip';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'//'../../../../redux/AppDucks'
import ModalDetalleHistorico from './ModalDetalleHistorico'
import { obtenerTodosDatosPredioGenerarGuias } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { Store } from 'react-notifications-component';
import { obtenerTodasConstanciasGuiaByIdDatosPredio, obtenerGuiaByIdDatosPredio } from '../../../redux/DucksUsuarioAgricola/ConstanciaDucks'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import ModalMensaje from "../ModalMensaje";
import estilos from "./PanelInformacionPredio.module.css"
import debounce from 'lodash.debounce';
const styleModalConfirmacion = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
  p: 4, fontSize: '20px', textAlign: 'center'
};


const PanelConsultarGuia = (props) => {

  const [modal, setModal] = React.useState(false)
  const [textoModal, setTextoModal] = React.useState('')
  const [tituloModal, setTituloModal] = React.useState('')
  const currentUser = useSelector(store => store.Usuario.data)
  const resetValores = (objectProducto) => {
    setModal(objectProducto.validacion)
  }

  const [tipoBusqueda, setTipoBusqueda] = React.useState("");
  const [numSocio, setNumSocio] = React.useState("");
  const [msjAlert, setMsjAlert] = useStateIfMounted("");
  //const [alert, setAlert] = useStateIfMounted(false);
  const [addGuia, setAddGuia] = React.useState(0);
  const [addVivero, setAddVivero] = React.useState();
  const [exito, setExito] = useStateIfMounted(false);
  const [noRegistro, setNoRegistro] = useState("");
  const [open, setOpen] = useState(false);
  const [numGuia, setNumGuia] = React.useState("");
  const [fRegistro, setFRegistro] = useState(new Date());
  const [dataMagueySelect, setDataMagueySelect] = React.useState([]);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [numTotalPlantas, setNumTotalPlantas] = React.useState(0);
  const [noIdentificador, setNoIdentificador] = React.useState("");

  const [errorAgregar, setErrorAgregar] = useStateIfMounted(false);
  const [socioSelecc, setSocioSelecc] = useState(false);
  const [predioSelecc, setPredioSelecc] = useState(false);
  const dispatch = useDispatch();
  //let dataCliente = [];
  const [dataCliente, setDataCliente] = useState(false);

  //dataCliente = useSelector((store) => store.InformacionValidaApi.data.data);
  let dataGuia = useSelector((store) => store.GuiaMagueyApi.data.data);
  //let dataPredios = useSelector((store) => store.DatosPredioApi.data.data);
  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
    pointerEvents: "required",
    cursor: "required",
  };
  const [predio, setPredio] = React.useState([])
  const [cliente, setCliente] = React.useState([])
  const [detalle, setDetalle] = React.useState(false)
  const [datosMaguey, setDatosMaguey] = React.useState([])
  const [dataPredios, setDataPredios] = useState([])

  const [numeroPredio, setNumeroPredio] = React.useState('')
  const [numeroGuia, setNumeroGuia] = React.useState('')

  const [infoGuia, setInfoGuia] = React.useState([])

  let columnsHistorico = []

  useEffect(() => {
    sumarValoresMaguey()

  }, [predio])

  const [guia, setGuia] = React.useState([]);

  const [modalConfirmar, setModalConfirmar] = React.useState(false);
  const [modalConfirmarLimpiar, setModalConfirmarLimpiar] = React.useState(false);


  const handleOpenConfirmar = (values) => {
    setModalConfirmar(true);

  }

  const handleCloseConfirmar = () => {
    setModalConfirmar(false);
  }

  const handleOpenConfirmarLimpiar = (values) => {
    setModalConfirmarLimpiar(true);

  }

  const handleCloseConfirmarLimpiar = () => {
    setModalConfirmarLimpiar(false);
  }

  const HTMLmodalConfirmarGenerarGuias = () => {
    let filterDatosMaguey = predio?.datosmaguey?.filter(anexo => anexo.edad >= 5)
    return (
      filterDatosMaguey && <Modal
        open={modalConfirmar}
        onClose={handleCloseConfirmar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Generar Guias</h3>
          Estás seguro de querer generar estas guias?<br></br>
          <br />
          <button onClick={btnGuardar} className='btn btn-danger'>Si, estoy seguro</button>
        </Box>

      </Modal>
    )
  }

  const HTMLmodalConfirmarLimpiar = () => {
    let filterDatosMaguey = predio?.datosmaguey?.filter(anexo => anexo.edad >= 5)
    return (
      filterDatosMaguey && <Modal
        open={modalConfirmarLimpiar}
        onClose={handleCloseConfirmarLimpiar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Limpiar Datos</h3>
          Estás seguro de querer limpiar los datos del predio?<br></br>
          <br />
          <button onClick={btnLimpiar} className='btn btn-danger'>Si, estoy seguro</button>
        </Box>

      </Modal>
    )
  }

  const btnGuardar = async (e) => {
    e.preventDefault()

    if (numTotalPlantas == 0) {
      handleCloseConfirmar()
      setTituloModal("Error")
      setTextoModal("Para agregar guias debes tener más de 1 planta")
      setModal(true)
    } else {
      try {
        await dispatch(actualizarLoadingApp_true())
        const guiasConst = { iddatospredio: Number(predio.iddatospredio), tipoconstancia: "NuevaGuia" }
        let guias = await dispatch(obtenerTodasConstanciasGuiaByIdDatosPredio(guiasConst))
        let estatus = await dispatch(obtenerGuiaByIdDatosPredio({ iddatospredio: predio.iddatospredio }))
        const numeroTotalGuias = Number(Number(guias.payload.length) + Number(addGuia))
        let contador = 1
        for (const i in guias.payload) {
          let { ...guiaEstatus } = guias.payload[i]

          const filtroEstatus = estatus.payload.filter(anexo => anexo.identificador == guiaEstatus.identificador)
          filtroEstatus[0].datosguia.page = Number(contador)
          filtroEstatus[0].datosguia.pages = numeroTotalGuias
          filtroEstatus[0].datosguia.datosmaguey = filtroEstatus?.[0].datosguia.datosmagueyproductor
          await dispatch(agregarGuia(filtroEstatus?.[0]?.datosguia))
          contador++
        }
        let lista = [];
        for (let index = 0; index < addGuia; index++) {
          let filterDatosMaguey = predio.datosmaguey.filter(anexo => anexo.edad >= 5)
          let identificador = uuidv4().toString().substring(0, 5)
          let datamaguey = []
          for (const i in filterDatosMaguey) {
            let { ...filtro } = filterDatosMaguey[i]
            filtro.especieCientifico = filtro.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
            datamaguey.push(filtro)
          }
          let dataNGuia = {
            datosmaguey: datamaguey,
            datosmagueyproductor: datamaguey,
            iddatospredio: Number(predio.iddatospredio),
            identificador: identificador,
            numerosocio: cliente.numerosocio,
            nombrerazonsocial: cliente.nombrerazonsocial,
            nombrepredio: predio.nombrepredio,
            estado: predio.estado,
            localidad: predio.localidad,
            municipio: predio.municipio,
            idcliente: cliente.idcliente,
            page: contador,
            pages: numeroTotalGuias
          }
          let constanciaRuta = await dispatch(agregarGuia(dataNGuia))
          contador++
          lista.push({
            iddatospredio: Number(predio.iddatospredio),
            constanciaruta: constanciaRuta?.data?.data,
            tipoguia: 1,
            fechacreacion: new Date(),
            usuariocreador: currentUser?.user?.[0]?.user,
            esactiva: true,
            identificador: identificador?.toUpperCase(),
            datosguia: {
              numerosocio: cliente?.numerosocio, identificador: identificador?.toUpperCase(), iddatospredio: Number(predio.iddatospredio),
              nombrerazonsocial: cliente?.nombrerazonsocial, datosmagueyproductor: datamaguey, nombrepredio: predio?.nombrepredio,
              municipio: predio?.municipio, localidad: predio?.localidad, estado: predio?.estado,
            }
          });
        }

        let value = await dispatch(agregarNuevaListaGuia({ data: lista })).unwrap();
        await dispatch(actualizarLoadingApp_false())
        setTituloModal("Informacion guardada correctamente!")
        setTextoModal("Guias generadas correctamente")
        setModal(true)

        setAddGuia(0)
        setErrorAgregar(false);
        handleCloseConfirmar()

      } catch (rejectedValueOrSerializedError) {
        setTituloModal("Error")
        setTextoModal("Ocurrio un error al generar las guias, revise la información")
        setModal(true)
      }

    }
  };
  const btnGenerarGuias = async (e) => {
    if (addGuia == 0) {
      //alert("El minimo de guias a generar es: 1")
      handleCloseConfirmar()
      setTituloModal("Mensaje")
      setTextoModal("El minimo de guias a generar es: 1")
      setModal(true)
      return
    } else {
      let estatus = await dispatch(obtenerGuiaByIdDatosPredio({ iddatospredio: Number(numeroPredio) }))
      let filtro = estatus.payload.filter(anexo => anexo.esactiva == true)
      if (filtro?.length == 0) {
        let hacerGuias = false

        if (predio.tipoguia == 'EXTEMPORÁNEO') {
          if ((estatus?.payload.length + Number(addGuia)) < 12) hacerGuias = true
        }
        if (predio.tipoguia == 'NORMAL') {
          if ((estatus?.payload.length + Number(addGuia)) < 16) hacerGuias = true
        }
        if (hacerGuias) {
          handleOpenConfirmar()
        } else {
          handleCloseConfirmar()
          setTituloModal("Mensaje")
          setTextoModal("Ya excedio el número de guias a generar")
          setModal(true)
        }
      } else {
        handleCloseConfirmar()
        setTituloModal("Mensaje")
        setTextoModal("Tiene guias activas por lo que no puede generar guias")
        setModal(true)
      }
      //handleOpenConfirmar()
    }
  }
  const [limpiar, setLimpiar] = React.useState(false);

  const btnLimpiar = async (e) => {
    await window.location.reload(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  /*useEffect(() => {
    //dispatch(obtenerTodosLosClientesConsulta());
    if (noIdentificador == '') {
      dispatch(obtenerTodosDatosPredioGenerarGuias(numeroPredio)).then((res) => {
        setDataPredios(res.payload.data.data)
      })
      dispatch(obtenerGuiaMagueyConsultaGuia()).then((r) => {
        setDatosMaguey(r.payload)
      })
    }

  }, [noIdentificador]);*/



  /*useEffect(async () => {
    await dispatch(obtenerTodosLosClientesConDetalle())
  }, []);*/


  const guardarRegistro = () => {
    let data = {
      // numeropredio: numMaxPredio +1,
      identificador: guia.identificador,
      datospredio: [
        {
          ...predio,
        },
      ],
      datosmaguey: dataTable.map((d) => {
        delete d.iddatosmaguey;
        delete d.especie;

        return d;
      }),
      tipoGuia: isUnaGuia.op,
    };
  };

  const enviarInfo = async () => {
    try {
      const respuesta = await guardarRegistro().unwrap();
      setExito(true);
    } catch (rejectedValueOrSerializedError) {
      setErrorAgregar(true);
    }
    setAlert(true);
  };


  const sumarValoresMaguey = () => {
    if (predio != null && predio?.datosmaguey !== null && predio?.datosmaguey !== undefined) {
      const filtrados = predio.datosmaguey.map(maguey => {
        if (maguey.edad >= 5)
          return maguey
      });
      let numTotal = filtrados.reduce((a, b) => a + (b ? b['numeroplantas'] : 0 || 0), 0);
      setNumTotalPlantas(numTotal)
    }

  }
  //
  const styleNormal = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
  };

  const btnGuardarModal = () => {
    alert("Se han guardado los registros. ");
  };

  const btnCancelarModal = (registroVivero) => {
    alert("Se han cancelado los registros. ");
    const arrayFiltrado = registroVivero.filter(
      (item) => item.addVivero !== addVivero
    );
    setAddVivero(arrayFiltrado);
  };

  const handlerSeleccion = (e) => {
    const { value } = e.target;
    if (!value.trim()) {
      setNoIdentificador("");
    }
    setNoIdentificador(value);
  };

  const handlerSeleccions = (value) => {
    setPredio(value);
    setCliente(value);
  };
  let isGuia = false
  let isNoPredio = false





  /*useEffect(() => {
    if (noIdentificador === "") {
      dispatch(setInitialData())
    }
  }, [noIdentificador]);*/
  const [rows, setRows] = useStateIfMounted([]);

  let columns = [

    {
      field: 'nombrecomun', headerName: 'Nombre Común', headerAlign: 'center', width: 320, sortable: false,
      renderCell: (params) =>
        <Tooltip title={`${params.row.catalogomaguey.nombrecomun}`} arrow>
          <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }} >{`${params.row.catalogomaguey.nombrecomun} `}</label>
        </Tooltip>
    },
    {
      field: 'nombrecientifico', headerName: 'Nombre Cientifico', headerAlign: 'center', width: 320, sortable: false,
      renderCell: (params) =>
        <Tooltip title={`${params.row.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico}`} arrow>
          <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico} `}</label>
        </Tooltip>
    },
    {
      field: 'numeroplantasregistro', headerName: 'Plantas registradas', headerAlign: 'center', width: 150, sortable: false,
      renderCell: (params) =>
        <Tooltip title={`${params.row.numeroplantasregistro}`} arrow>
          <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.numeroplantasregistro} `}</label>
        </Tooltip>
    },
    {
      field: 'numeroplantas', headerName: 'Existencia', headerAlign: 'center', width: 100, sortable: false,
      renderCell: (params) =>
        <Tooltip title={`${params.row.numeroplantas}`} arrow>
          <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.numeroplantas} `}</label>
        </Tooltip>
    },
    {
      field: 'edad', headerName: 'Edad', headerAlign: 'center', width: 100, sortable: false,
      renderCell: (params) =>
        <Tooltip title={`${params.row.edad}`} arrow>
          <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.edad} `}</label>
        </Tooltip>
    },
    {
      field: 'guias', headerName: 'Guias usadas', headerAlign: 'center', width: 150, sortable: false,
      renderCell: (params) => (
        <Fragment>
          <button className={'btn ms-1'} style={{ background: '#68813c', color: 'white' }} onClick={() => { setDataDetalle(params.row.datosmagueyhistorico), setDetalle(true) }} >Historial</button>
        </Fragment>

      )
    }
  ]

  const [dataDetalle, setDataDetalle] = React.useState([])
  const VerModalDetalle = (objeto) => {
    setDetalle(objeto)
  }

  //const idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();

  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };

  const busquedaNoCliente = (values) => {

  }
  const handlerSeleccionNumCliente = (value) => {

    if (numeroPredio == '') {
      setCliente(value)
      setDataPredios(value?.datospredio)
      setNoIdentificador(value.numerosocio)
      /*let datos = []
      for(const i in value?.datospredio){
        let {...datopredio} = value?.datospredio
        datopredio.iddatospredio = idPredio(datopredio.iddatospredio)
      }*/
    }
  };
  const handlerSeleccionNumPredio = (value) => {
    if (noIdentificador != '') {
      //let filtro = value?.constancia?.filter(anexo => anexo?.tipoconstancia == 'NuevaGuia')
      let guiasEstatus = []
      for (const x in value?.constancia) {
        let { ...constancia } = value?.constancia?.[x]
        if (constancia.tipoconstancia == 'NuevaGuia') {
          let estatus = value?.guias?.filter(anexo => anexo.identificador == constancia?.identificador)
          constancia.esactiva = estatus?.[0]?.esactiva
          guiasEstatus.push(constancia)
        }
      }
      setDatosMaguey(guiasEstatus)

      setPredio(value)
      if (noIdentificador != value?.cliente?.numerosocio && value?.cliente?.numerosocio != null && value?.cliente?.numerosocio != undefined) setNoIdentificador(value?.cliente?.numerosocio)
      let datosMagueInf = []
      for (const k in value?.datosmaguey) {
        let { ...infMaguey } = value?.datosmaguey?.[k]
        infMaguey.id = uuidv4()
        infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
        infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
        let datahistorico = []
        for (const l in infMaguey?.datosmagueyhistorico) {
          let { ...historicoData } = infMaguey?.datosmagueyhistorico?.[l]
          let filtroHistorico = value?.constancia?.filter(anexo => anexo?.idconstancia == historicoData?.idconstancia)
          historicoData.identificador = filtroHistorico?.[0]?.identificador
          datahistorico.push(historicoData)
        }
        infMaguey.datosmagueyhistorico = datahistorico
        datosMagueInf.push(infMaguey)
      }
      setRows(datosMagueInf)
    }
    if (noIdentificador == '') {
      setNumeroPredio(idPredio(value?.iddatospredio))
      setNoIdentificador(value?.cliente?.numerosocio)
      setCliente(value?.cliente)
      setPredio(value)
      let datosMagueInf = []
      for (const k in value?.datosmaguey) {
        let { ...infMaguey } = value?.datosmaguey?.[k]
        infMaguey.id = uuidv4()
        infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
        infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
        let datahistorico = []
        for (const l in infMaguey?.datosmagueyhistorico) {
          let { ...historicoData } = infMaguey?.datosmagueyhistorico?.[l]
          let filtroHistorico = value?.constancia?.filter(anexo => anexo?.idconstancia == historicoData?.idconstancia)
          historicoData.identificador = filtroHistorico?.[0]?.identificador
          datahistorico.push(historicoData)
        }
        infMaguey.datosmagueyhistorico = datahistorico

        datosMagueInf.push(infMaguey)
      }
      setRows(datosMagueInf)
      /*let filtro = value?.constancia?.filter(anexo => anexo?.tipoconstancia == 'NuevaGuia')
      setDatosMaguey(filtro)*/
      let guiasEstatus = []
      for (const x in value?.constancia) {
        let { ...constancia } = value?.constancia?.[x]
        if (constancia.tipoconstancia == 'NuevaGuia') {
          let estatus = value?.guias?.filter(anexo => anexo.identificador == constancia?.identificador)
          constancia.esactiva = estatus?.[0]?.esactiva
          guiasEstatus.push(constancia)
        }
      }
      setDatosMaguey(guiasEstatus)
    }
  }

  const handlerSeleccionNumGuia = (value) => {
    if (value.tipoconstancia !== "NuevaGuia") {
      setNumeroPredio(idPredio(value?.datospredio?.iddatospredio))
      setNoIdentificador(value?.datospredio?.cliente?.numerosocio)
      setCliente(value?.datospredio?.cliente)
      setPredio(value?.datospredio)
      let datosMagueInf = []
      for (const k in value?.datospredio?.datosmaguey) {
        let { ...infMaguey } = value?.datospredio?.datosmaguey?.[k]
        infMaguey.id = uuidv4()
        infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
        infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
        let datahistorico = []
        for (const l in infMaguey?.datosmagueyhistorico) {
          let { ...historicoData } = infMaguey?.datosmagueyhistorico?.[l]
          let filtroHistorico = value?.datospredio?.constancia?.filter(anexo => anexo?.idconstancia == historicoData?.idconstancia)
          historicoData.identificador = filtroHistorico?.[0]?.identificador
          datahistorico.push(historicoData)
        }
        infMaguey.datosmagueyhistorico = datahistorico
        datosMagueInf.push(infMaguey)
      }
      setDatosMaguey(datosMaguey?.filter(anexo => anexo.iddatospredio == value?.datospredio?.iddatospredio))
      setRows(datosMagueInf)
      setInfoGuia(value)
    }
    if (value.tipoconstancia == "NuevaGuia") {
      setInfoGuia(value)
    }
  };
  const searchGuia = async (valores) => {
    //await dispatch(actualizarLoadingApp_true())
    let estatus = false
    let datosMagueInf = []
    if (valores.tipoconstancia != 'NuevaGuia') {
      if (valores.numerosocio != null && numeroPredio == '') {
        setDataPredios(valores.datospredio)
        setCliente(valores)
        setDatosMaguey([])
      }
      if (valores?.iddatospredio != null && cliente?.length != 0) {
        setNoIdentificador(valores?.cliente?.numerosocio)
        setPredio(valores)
        for (const k in valores.datosmaguey) {
          let { ...infMaguey } = valores?.datosmaguey?.[k]
          infMaguey.id = uuidv4()
          infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
          infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
          datosMagueInf.push(infMaguey)
        }
        setRows(datosMagueInf)
        let filtro = valores?.constancia?.filter(anexo => anexo?.tipoconstancia == 'NuevaGuia')
        setDatosMaguey(filtro)
        //setDatosMaguey([])
        /*let filtro = valores.constancia.filter(anexo => anexo.tipoconstancia == 'NuevaGuia')
        setDatosMaguey(filtro)*/
      }
      if (cliente?.length == 0 && (valores?.idguias == null || valores?.idguias == undefined)) {
        setNoIdentificador(valores.cliente.numerosocio)
        setCliente(valores.cliente)
        setPredio(valores)

        for (const k in valores.datosmaguey) {
          let { ...infMaguey } = valores?.datosmaguey?.[k]
          infMaguey.id = uuidv4()
          infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
          infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
          datosMagueInf.push(infMaguey)
        }
        setRows(datosMagueInf)
        let filtro = valores?.constancia?.filter(anexo => anexo.tipoconstancia == 'NuevaGuia')
        setDatosMaguey(filtro)
        //setDatosMaguey([])
      }
      if (cliente?.length == 0 && (valores?.idguias != null || valores?.idguias != undefined)) {
        setNumeroPredio(idPredio(valores?.datospredio?.iddatospredio))
        setCliente(valores?.datospredio?.cliente)
        setPredio(valores?.datospredio)
        for (const k in valores?.datospredio?.datosmaguey) {
          let { ...infMaguey } = valores?.datospredio?.datosmaguey?.[k]
          infMaguey.id = uuidv4()
          infMaguey.nombrecomun = infMaguey.catalogomaguey.nombrecomun
          infMaguey.nombrecientifico = infMaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico
          datosMagueInf.push(infMaguey)
        }
        setRows(datosMagueInf)
        setInfoGuia(valores)
      }
    }

  };





  const fetchClientes = React.useMemo(() => debounce(async (value) => {
    if (value.trim() === '') {
      setDataCliente([]);
      return;
    }
    const resultado = await dispatch(obtenerClientesDetalleLike(value));
    setDataCliente(resultado?.payload?.data?.data || []);
  }, 500), [dispatch]);

  useEffect(() => {
    fetchClientes(noIdentificador);

    // Limpia debounce al desmontar
    return () => {
      fetchClientes.cancel();
    };
  }, [noIdentificador]);



  const buscarPredios = useMemo(() => debounce(async (valor) => {
    if (!valor.trim()) {
      setDataPredios([]);
      return;
    }
    const resultado = await dispatch(obtenerTodosDatosPredioGenerarGuias(valor));
    setDataPredios(resultado?.payload?.data?.data || []);
  }, 500), [dispatch]);

  // Efecto para llamar a la búsqueda cuando cambia el input
  useEffect(() => {
    buscarPredios(numeroPredio);
    return () => buscarPredios.cancel();
  }, [numeroPredio]);


  const buscarGuias = useMemo(() => debounce(async (valor) => {
    if (!valor.trim()) {
      setDatosMaguey([]);
      return;
    }
    const resultado = await dispatch(obtenerGuiaMagueyConsultaGuia(valor));
    setDatosMaguey(resultado?.payload || []);
  }, 500), [dispatch]);

  // Efecto para llamar a la búsqueda cuando cambia el input
  useEffect(() => {
    buscarGuias(numeroGuia);
    return () => buscarGuias.cancel();
  }, [numeroGuia]);

  return (
    <Fragment>
      <br />
      <br />
      <div className="container">
        <h2 className="text-center">Generar Nuevas Guias</h2>
        <br />
        <div className="row">
          <div className="text-end">

            <Button onClick={btnLimpiar} className="col-3 btn-success"> Limpiar datos </Button>
          </div>

          <div className="row">
            <div className='col'>
              <label className="form-label">
                <b>No. de Cliente:</b>
              </label>
              <div className="form-floating mb-3">
                {dataPredios &&
                  <Autocomplete
                    freeSolo //open={open}
                    inputValue={noIdentificador !== null && noIdentificador !== undefined ? noIdentificador : ""}
                    /*onOpen={() => { if (noIdentificador) { setOpen(true); } }}
                    onClose={() => setOpen(false)}*/
                    onInputChange={(e, value) => {
                      setNoIdentificador(value);
                    }}
                    onChange={(event, value) => { handlerSeleccionNumCliente(value); }}
                    options={dataCliente ? dataCliente : []}

                    getOptionLabel={(opcion) =>
                      opcion ? opcion.numerosocio + "" : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                        size="small" style={{ background: "white" }} fullWidth
                      //onKeyDown={e => { !open && e.key === "Enter" && e.stopPropagation(); }}
                      />
                    )}
                  />}

              </div>
            </div>
            <div className='col'>
              <label className="form-label">
                <b>No. de Predio:</b>
              </label>
              <div className="form-floating mb-3">

                {dataPredios &&
                  <Autocomplete
                    freeSolo //open={open}
                    inputValue={(numeroPredio != null && numeroPredio != undefined && numeroPredio != '') ? idPredio(numeroPredio, 5) : ""}
                    /*onOpen={() => { if (noIdentificador) { setOpen(true); } }}
                    onClose={() => setOpen(false)}*/
                    onInputChange={(e, value) => {
                      setNumeroPredio(value);
                    }}
                    onChange={(event, value) => { handlerSeleccionNumPredio(value); }}
                    options={dataPredios ? dataPredios : []}
                    getOptionLabel={(opcion) =>
                      opcion ? idPredio(opcion?.iddatospredio, 5) + "" : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                        size="small" style={{ background: "white" }} fullWidth
                      //onKeyDown={e => { !open && e.key === "Enter" && e.stopPropagation(); }}
                      />
                    )}
                  />
                }
              </div>
            </div>
            <div className='col'>
              <label className="form-label">
                <b>No. de Guia:</b>
              </label>
              <div className="form-floating mb-3">
                {datosMaguey &&
                  <Autocomplete
                    freeSolo //open={open}
                    inputValue={(numeroGuia != null && numeroGuia != undefined && numeroGuia != '') ? numeroGuia : ""}
                    /*onOpen={() => { if (noIdentificador) { setOpen(true); } }}
                    onClose={() => setOpen(false)}*/
                    onInputChange={(e, value) => {
                      setNumeroGuia(value);
                      //if (!value) { setOpen(false); }
                    }}
                    onChange={(event, value) => { handlerSeleccionNumGuia(value); }}
                    options={datosMaguey ? datosMaguey : []}

                    getOptionLabel={(opcion) =>
                      opcion ? opcion?.identificador?.toUpperCase() + "" : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                        size="small" style={{ background: "white" }} fullWidth
                      //onKeyDown={e => { !open && e.key === "Enter" && e.stopPropagation(); }}
                      />
                    )}
                  />
                }
              </div>
            </div>
          </div>
          {/*(tipoBusqueda == 'guia' || tipoBusqueda == 'predio' || tipoBusqueda == 'cliente') &&
            <div className='text-center'>
              <Button onClick={searchGuia} > Buscar </Button>
              <br />
              <br />
            </div> */}
          <hr />
          <div className="text-center">
            <h5 className={`${estilos.labelEspecial} text-center `}><strong>DATOS DEL ASOCIADO</strong></h5>
            <br />
          </div>
          <div className="row">
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
              <div className="form-floating mb-3">
                <input type="text" className={`form-control`} value={cliente?.nombrerazonsocial ? cliente?.nombrerazonsocial : ''} disabled />
                <label className="label-dark" htmlFor="floatingInput"><strong>Nombre del cliente:</strong></label>
              </div>
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
              <div className="form-floating mb-3">
                <input type="text" className={`form-control`} value={predio?.nombrepredio ? predio?.nombrepredio : ''} disabled />
                <label className="label-dark" htmlFor="floatingInput"><strong>Nombre del predio:</strong></label>
              </div>
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
              <div className="form-floating mb-3">
                <input type="text" className={`form-control`} value={predio?.fecharegistro?.substring(0, 10) ? predio?.fecharegistro?.substring(0, 10) : ''} disabled />
                <label className="label-dark" htmlFor="floatingInput"><strong>Fecha de registro:</strong></label>
              </div>
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
              <div className="form-floating mb-3">
                <input type="text" className={`form-control`} value={infoGuia?.esactiva != null ? infoGuia?.esactiva == true ? "Activa" : "Inactiva" : ''} disabled />
                <label className="label-dark" htmlFor="floatingInput"><strong>Estatus:</strong></label>
              </div>
            </div>
          </div>

        </div>
        <hr />
        <div className='row justify-content-center'>
          <div className='col-12'>
            <div style={{ width: '103%', color: 'black' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                disableColumnMenu
                pageSize={5}
                autoHeight
                sx={{
                  boxShadow: 0,
                  color: 'black',
                  border: 0,
                  '& .MuiDataGrid-cell': {
                    display: 'block',
                    position: 'relative',
                    textAlign: 'center',
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <h4 className={`${estilos.labelEspecial} text-center mb-3 `}>Generación de Guías</h4>
          <div className='col-6 text-center'>
            <div className="form-floating mt-3 mb-3">
              <input type="number" className={`form-control form-control-sm`}
                id="" placeholder='Generar Guias:' min={0}
                name="noIdentificador" value={addGuia}
                onChange={e => { setAddGuia(e.target.value) }} />
              <label className="label-dark" htmlFor="floatingInput">Generar Guías:</label>
            </div>
          </div>
          <div className='col-6 text-center mt-3'>
            <button className="btn btn-primary" onClick={btnGenerarGuias} disabled={cliente?.idcliente ? false : true}>Generar Guías</button>
          </div>

        </div>
        <br />
        <div className='row' style={{ alignContent: 'center' }}>
          <div align="center">
            <Button className="btn-success" onClick={handleOpenConfirmarLimpiar}>Finalizar</Button>
          </div>
        </div>
      </div>
      {detalle && <ModalDetalleHistorico api={{ VerModalDetalle, dataDetalle, detalle }} columns={columnsHistorico} />}
      {modal && <ModalMensaje texto={textoModal} titulo={tituloModal} api={{ resetValores }}></ModalMensaje>}
      {HTMLmodalConfirmarGenerarGuias()}
      {HTMLmodalConfirmarLimpiar()}
    </Fragment>
  );
};

export default withRouter(PanelConsultarGuia);
